import type { AbstractControl } from '@angular/forms';

/** WN-992: asset names carry both languages; show the UI language's, falling back to the other one. */
export function pickLocalizedTitle(en: string | null | undefined, ar: string | null | undefined, arabic: boolean): string {
  const e = en?.trim();
  const a = ar?.trim();
  return (arabic ? a || e : e || a) || '-';
}

/** WN-993: a missing value and a value in the wrong script are different messages. */
export function titleErrorKey(control: AbstractControl): string | null {
  if (!control.touched || control.valid) return null;
  if (control.hasError('required')) return 'ASSET_EDITOR.REQUIRED';
  if (control.hasError('englishTitle')) return 'ASSET_EDITOR.TITLE_EN_LANGUAGE';
  return null;
}
